import React from "react";
import {
  CWBAPI,
  CWBLoadingCrest,
  getSessionDataFromAuthToken,
  setUserAuthToken,
} from "cwb-react";
import qs from "query-string";
import { withI18n } from "react-i18next";
import styled, { css } from "styled-components";
import CWBLogin from "./screens/Login";
import CWBLabsLogin from "./screens/CWBLabsLogin";
import { client } from "shared/apiClient";
import CWBLogoGrey from "images/icon-cwb-logo-grey.svg";
import { redirectAuthenticated, checkProducerPhoneVerification } from "../../shared/helpers";

class Login extends React.Component {
  state = {
    errors: {
      workbookId: "",
      password: "",
    },
    errorMessage: null,
    user: {
      workbookId: "",
      password: "",
    },
    isLoading: true,
    rememberMe: false,
    showFakePassword: false,
    checkedTerms: false,
    isMissingAcceptance: false,
    isRedirectLoading: false,
  };

  async componentWillMount() {
    let api = await import(`cwb-react/dist/${CWB_API_FILE}`);
    let localApi = await import(`shared/api`);
    client.api = new CWBAPI(
      { ...api.default, ...localApi.default },
      CWB_API_ENV,
      CWB_USE_MOCK_ENV
    );

    await this.checkAutoLogin();

    this.rememberMeData = JSON.parse(localStorage.getItem("CWB_REMEMBER_ME"));

    if (this.rememberMeData) {
      this.setState((oldState) => {
        return {
          rememberMe: true,
          showFakePassword: true,
          user: {
            ...oldState.user,
            workbookId: this.rememberMeData.userName,
            password: this.rememberMeData.refreshToken,
          },
        };
      });
    }

    const params = qs.parse(this.props.location.search);
    if (params.login) {
      if (params.login.startsWith("*|") == false && params.login.startsWith("{") == false) {
        this.setState({
          user: {
            ...this.state.user,
            workbookId: params.login,
          },
        });
      }
    }

    this.setIsLoading(false);
  }

  componentDidMount() {
    window.addEventListener("pageshow", this.handlePageShow.bind(this));
  }

  componentWillUnmount() {
    this.setIsLoading(false);
    window.removeEventListener("pageshow", this.handlePageShow.bind(this));
  }

  // If the app has redirected to an external page and the user clicks on
  // the back button the app (and its state) might have been saved in the
  // BFCache thus retaining the loading state. In that case here we turn
  // off the redirection loading spinner
  handlePageShow() {
    if (this.state.isRedirectLoading) {
      this.setState({ isRedirectLoading: false })
    }
  };

  checkAutoLogin = async () => {
    const queryString = qs.parse(this.props.location.search);
    if (
      queryString.page === "infosheet" &&
      queryString.sch &&
      queryString.saud
    ) {
      try {
        const tokenResp = await client.api.user.getAuthToken();
        const authToken =
          tokenResp && tokenResp.data && tokenResp.data.accessToken;

        const decoded = getSessionDataFromAuthToken(authToken);

        if (Number(decoded.UserType) === 8) {
          const search = qs.parse(this.props.location.search);
          if (search.ac === 'true') {
            const searchString = qs.stringify({ ...search, k: decodedToken.WebSessionKey });
            return this.props.history.push(`/login/new-presentation?${searchString}`);
          }

          return this.redirectUserToTheirIndexPage(
            decoded.UserType,
            decoded.WebSessionKey,
            decoded.UserId,
            authToken
          );
        }
      } catch (e) { }
    }
  };

  getErrorMessage = (field, value) => {
    if (field === "workbookId") {
      return value
        ? ""
        : this.props.t("Email or Casting Workbook ID is required.");
    } else if (field === "password") {
      return value ? "" : this.props.t("Password is required.");
    } else {
      return "";
    }
  };

  onChangeField = (field, value) => {
    if (field === "password") {
      this.clearRememberMeData();
    }

    this.setState((oldState) => {
      return {
        errors: {
          ...oldState.errors,
          [field]: this.getErrorMessage(field, value),
        },
        user: {
          ...oldState.user,
          [field]: value,
        },
        showFakePassword:
          field === "password" ? false : oldState.showFakePassword,
      };
    });
  };

  onSetErrorMessage = (msg) => {
    this.setState({
      errorMessage: msg,
    });
  };

  onKeyPress = (event) => {
    if (event.key === "Enter") {
      document.getElementById("login-btn").click();
      event.preventDefault();
    }
  };

  setIsLoading = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  shouldLoginViaToken = () => {
    if (
      this.rememberMeData &&
      this.rememberMeData.refreshToken &&
      this.rememberMeData.userName == this.state.user.workbookId
    ) {
      return true;
    } else {
      return false;
    }
  };

  toggleRememberMe = () => {
    this.setState((oldState) => {
      return {
        rememberMe: !oldState.rememberMe,
      };
    });
  };

  saveRememberMeData = (decodedAccessToken, refreshToken) => {
    if (!decodedAccessToken || !refreshToken) {
      return;
    }

    localStorage.setItem(
      "CWB_REMEMBER_ME",
      JSON.stringify({
        userName: this.state.user.workbookId,
        userId: decodedAccessToken.UserId,
        userType: decodedAccessToken.UserType,
        refreshToken,
      })
    );
  };

  clearRememberMeData = () => {
    localStorage.removeItem("CWB_REMEMBER_ME");
    this.rememberMeData = null;
  };

  redirectUserToTheirIndexPage = (userType, webSessionKey, userId, token, isProducer=false) => {
    let queryString = qs.parse(this.props.location.search);

    if (!webSessionKey.startsWith("{")) {
      webSessionKey = "{" + webSessionKey + "}";
    }

    delete queryString.signup;
    delete queryString.signUp;

    return redirectAuthenticated(
      userType,
      webSessionKey,
      userId,
      queryString,
      token,
      isProducer,
    )
  };

  checkValidation = () => {
    const newErrors = {
      workbookId: this.getErrorMessage(
        "workbookId",
        this.state.user.workbookId
      ),
      password: this.getErrorMessage("password", this.state.user.password),
    };

    this.setState({ errors: newErrors });
    return !Object.values(newErrors).reduce((acc, cur) => {
      return acc + cur;
    }, "");
  };

  onSubmit = async () => {
    this.onSetErrorMessage(null);
    if (!this.checkValidation()) return;
    //this.setIsLoading(true);
    this.setState({ isRedirectLoading: true });

    try {
      let loginResponse;

      if (this.shouldLoginViaToken()) {
        loginResponse = await client.api.user.refreshLogin(this.rememberMeData);
      } else {
        loginResponse = await client.api.user.loginToCWBWithTermsAndConditions(
          this.state.user.workbookId,
          this.state.user.password,
          this.state.checkedTerms
        );
      }

      if (loginResponse.data && loginResponse.data.accessToken) {
        await setUserAuthToken(loginResponse.data.accessToken);
        var decodedToken = getSessionDataFromAuthToken(
          loginResponse.data.accessToken
        );

        const { isProducer, redirected } = await checkProducerPhoneVerification(
          decodedToken,
          loginResponse.data.accessToken
        );

        if (redirected) {
          return;
        }

        if (this.state.rememberMe) {
          this.saveRememberMeData(
            decodedToken,
            loginResponse.data.refreshToken
          );
        } else {
          this.clearRememberMeData();
        }

        const search = qs.parse(this.props.location.search);
        if (search.ac === 'true') {
          const searchString = qs.stringify({ ...search, k: decodedToken.WebSessionKey });
          return this.props.history.push(`/login/new-presentation?${searchString}`);
        }

        return this.redirectUserToTheirIndexPage(
          decodedToken.UserType,
          decodedToken.WebSessionKey,
          decodedToken.UserId,
          loginResponse.data.accessToken,
          isProducer
        );
      }
      
    } catch (error) {
      this.setState({ isRedirectLoading: false });

      if (
        error.response &&
        error.response.data &&
        error.response.data.isMissingAcceptance
      ) {
        this.setState({ isMissingAcceptance: true });
      } else {

        let message = this.props.t("Invalid login attempt.");
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else {
          console.log(error);
        }
        this.onSetErrorMessage(message);
      }
    }
    this.setIsLoading(false);
    this.setState({ isRedirectLoading: false });
  };

  render() {
    const { user, isLoading, isRedirectLoading } = this.state;
    const isCWBLabs = qs.parse(location.search).cwblabs;

    if (!user || (isLoading || isRedirectLoading)) {
      return (
        <StyledDiv isCWBLabs={isCWBLabs}>
          <CWBLoadingCrest customLogoSrc={CWBLogoGrey} />
        </StyledDiv>
      );
    }

    return isCWBLabs ? (
      <CWBLabsLogin
        checkedTerms={this.state.checkedTerms}
        errors={this.state.errors}
        errorMessage={this.state.errorMessage}
        isMissingAcceptance={this.state.isMissingAcceptance}
        rememberMe={this.state.rememberMe}
        showFakePassword={this.state.showFakePassword}
        user={user}
        onChangeField={this.onChangeField}
        onCheckTerms={() => {
          this.setState({ checkedTerms: !this.state.checkedTerms });
        }}
        onKeyPress={this.onKeyPress}
        onSubmit={this.onSubmit}
        toggleRememberMe={this.toggleRememberMe}
      />
    ) : (
      <CWBLogin
        checkedTerms={this.state.checkedTerms}
        errors={this.state.errors}
        errorMessage={this.state.errorMessage}
        isMissingAcceptance={this.state.isMissingAcceptance}
        rememberMe={this.state.rememberMe}
        showFakePassword={this.state.showFakePassword}
        user={user}
        onChangeField={this.onChangeField}
        onCheckTerms={() => {
          this.setState({ checkedTerms: !this.state.checkedTerms });
        }}
        onKeyPress={this.onKeyPress}
        onSubmit={this.onSubmit}
        toggleRememberMe={this.toggleRememberMe}
        isRedirectLoading={this.isRedirectLoading}
      />
    );
  }
}

const StyledDiv = styled.div`
  ${(p) =>
    p.isCWBLabs &&
    css`
      height: calc(100% - 80px);
      background-color: #040f1c;
    `}
`;

export default withI18n()(Login);
